import { Container, Box, Typography,  Grid, IconButton, Link, Divider } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import * as constants from './utils/constants'
import LocationOnIcon from '@mui/icons-material/LocationOn';

function Footer() {
    return (
        <Box component="footer" sx={{ background: '#ffffff', p:2, borderTop: '1px solid rgba(255, 255, 255, 0.12)' }}>
            <Container maxWidth="lg">
                <Grid container spacing={5} justifyContent="center">
                    <Grid item xs={12} sm={6} md={4}>
                        <Typography variant="h6" fontWeight="bold" gutterBottom>
                            Contact Info
                        </Typography>
                        <Link href={`mailto:${constants.EMAIL}?subject=Hello&body=Hi there!`}
                        underline="hover"
                        color="primary">
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                
                                    <EmailIcon sx={{ mr: 1  }} />
                                    <Typography variant="body2" color="#3b7bd5">{constants.EMAIL}</Typography>
                            </Box>
                        </Link>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <PhoneIcon sx={{ color:"#3b7bd5", mr: 1  }} />
                            <Typography variant="body2" color="#3b7bd5">{constants.MOBILE_NO}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <LocationOnIcon sx={{ color:"#3b7bd5", mr: 1  }} />
                            <Typography variant="body2" color="#3b7bd5">{constants.ADDRESS}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} sx={{ textAlign: { sm: 'center' } }}>
                        <Typography variant="h6" fontWeight="bold"  gutterBottom>
                            Follow Us
                        </Typography>
                        <IconButton href="#" sx={{color:"#3b7bd5", '&:hover': { color: 'primary.light' } }}><FacebookIcon /></IconButton>
                        <IconButton href="#" sx={{color:"#3b7bd5",  '&:hover': { color: 'primary.light' } }}><TwitterIcon /></IconButton>
                        <IconButton href="#" sx={{color:"#3b7bd5",  '&:hover': { color: 'primary.light' } }}><InstagramIcon /></IconButton>
                        <IconButton href="#" sx={{color:"#3b7bd5",  '&:hover': { color: 'primary.light' } }}><LinkedInIcon /></IconButton>
                    </Grid>
                    <Grid item xs={12} md={4} sx={{ textAlign: { md: 'right' } }}>
                        <Typography variant="h6" fontWeight="bold"  gutterBottom>
                            {constants.BRAND_NAME}
                        </Typography>
                        <Typography variant="body2" color="#3b7bd5">
                            Innovating for a better tomorrow.
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
            <Divider color='#2b394a' sx={{width:'100%', mt: 2}}/>
            <Container maxWidth="lg">
                <Typography variant="body2" color="black" align="center" sx={{ fontWeight:'bold', mt: 1, borderTop: '1px solid rgba(255, 255, 255, 0.12)' }}>
                    {'Copyright © '}
                    {constants.BRAND_NAME}
                    {'.'}
                </Typography>
            </Container>
        </Box>
    );
}

export default Footer